import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import countries from '../../Data/Countries.json';
import moment from 'moment';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import DefaultData from '../../CompanyData/DefaultData';
import { useAuth } from '../../Common/Configurations/AuthContext';
const FlightDetails = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { user, loading } = useAuth();
    const [minDate, setMinDate] = useState('');
    const [errors, setErrors] = useState({});
    const [passportErrors, setPassportErrors] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState({});
    const [itinerary, setItinerary] = useState([]);
    const [legs, setLegs] = useState([]);
    const [adultTravellers, setAdultTravellers] = useState([]);
    const [kidTravellers, setKidTravellers] = useState([]);
    const [infantTravellers, setInfantTravellers] = useState([]);
    const [totalTravellers, setTotalTravellers] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [baseFare, setBaseFare] = useState(0);
    const [tax, setTax] = useState(0);
    const [totalFare, setTotalFare] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0)
    const [convenienceFee, setConvenienceFee] = useState(0)
    const [email, setEmail] = useState(user?.email);
    const [mobile, setMobile] = useState(user?.phoneNumber);
    const [paymentGatewayFee, setPaymentGatewayFee] = useState(0);
    const [paymentGatewayAmount, setPaymentGatewayAmount] = useState(0);
    const [companyGST, setCompanyGST] = useState(user?.companygstno);
    const [companyName, setCompanyName] = useState(user?.companyname);
    const [companyAddress, setCompanyAddress] = useState(user?.companyaddress);
    const [bookingStatus, setBookingStatus] = useState('');
    const [currency, setCurrency] = useState(DefaultData?.DEFAULTCURRENCY || "INR");
    const [exchangeRates, setExchangeRates] = useState([]);
    const [conversionFactor, setConversionFactor] = useState(1);
    const [passedMarkupINR, setPassedMarkupINR] = useState(0);
    useEffect(() => {
        const getCurrencies = async () => {
            try {
                const response = await apiService.get(`${config.GETCURRENCY}`, 1000, 1);
                if (response?.data) setExchangeRates(response.data);
            } catch (error) { console.error(error); }
        };
        getCurrencies();
    }, []);

    // 2. Set Conversion Factor based on User Profile
    useEffect(() => {
        if (user?.currency && exchangeRates.length > 0) {
            setCurrency(user.currency);
            const rateData = exchangeRates.find(r => r.fromCurrency === "INR" && r.toCurrency === user.currency);
            setConversionFactor(rateData ? rateData.price : 1);
        }
    }, [user, exchangeRates]);
    const calculatePrice = (amountInINR) => {
        const finalINR = parseFloat(amountInINR || 0);
        const converted = finalINR * conversionFactor;
        
        if (currency === "INR") {
            return Math.round(converted).toLocaleString("en-IN");
        } else {
            return converted.toFixed(2);
        }
    };

    // 4. Extract Markup from state
    useEffect(() => {
        if (state?.markupInINR) {
            setPassedMarkupINR(parseFloat(state.markupInINR));
        }
    }, [state]);
    function getformtravelData(tData) {
        var gender = "MALE";
        if (tData.title === "Mr") {
            gender = "MALE";
        }
        else if (tData.title === "Mrs") {
            gender = "FEMALE";
        }
        else if (tData.title === "Ms") {
            gender = "FEMALE";
        }
        else if (tData.title === "Master") {
            gender = "MALE";
        }
        const myObject = {
            travelerId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            firstName: tData.firstName,
            lastName: tData.lastName,
            title: tData.title,
            gender: gender,
            travelerType: tData.type,
            //dateOfBirth: moment(tData.dateOfBirth).format('YYYY-MM-DD'),
            dateOfBirth: params.isDomestic === 'INTERNATIONAL' ? moment(tData.dateOfBirth).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passportNo: tData.passportNo,
            passportNationality: tData.passportNationality,
            passbookIssueDate: params.isDomestic === 'INTERNATIONAL' ? moment(tData.passbookIssueDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passbookExpireDate: params.isDomestic === 'INTERNATIONAL' ? moment(tData.passbookExpireDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        };
        return myObject;
    }
    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }
    const handleMobileChange = (e) => {
        setMobile(e.target.value)
    }
    const validate = (index, adata) => {
        let temp = {};
        temp.firstName = adata.firstName === "" ? false : true;
        temp.lastName = adata.lastName === "" ? false : true;
        if (params.isDomestic === 'INTERNATIONAL') {
            temp.dateOfBirth = adata.dateOfBirth === "" ? false : true;
            temp.passportNo = adata.passportNo === "" ? false : true;
            temp.passportNationality = adata.passportNationality === "" ? false : true;
            temp.passbookIssueDate = adata.passbookIssueDate === "" ? false : true;
            temp.passbookExpireDate = adata.passbookExpireDate === "" ? false : true;
        }
        temp.email = email === "" ? false : true;
        temp.mobile = mobile === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const [errorAdult, setAdultError] = useState('');
    const [errorKid, setKidError] = useState('');
    const [errorInfant, setInfantError] = useState('');
    const validateAdultDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 100;
        if (year.length > 4 && event.target.value) {
            setAdultError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setAdultError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...adultTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setAdultTravellers(values);
            setAdultError('');
        }
    };
    const validateKidsDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 12;
        if (year.length > 4 && event.target.value) {
            setKidError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setKidError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...kidTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setKidTravellers(values);
            setKidError('');
        }
    };
    const validateInfantDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 2;
        if (year.length > 4 && event.target.value) {
            setInfantError('The year must be 4 digits!');
            event.target.value = ''; // Clear the input value
        }
        if (year < minYear || year > currentYear) {
            setInfantError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = ''; // Clear the input value
        }
        else {
            const values = [...infantTravellers];
            const updatedValue = event.target.name;
            values[index][updatedValue] = event.target.value;
            setInfantTravellers(values);
            setInfantError('');
        }
    };
    const handleAdultChange = (index, event) => {
        const values = [...adultTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setAdultTravellers(values);
    };
    const handleKidsChange = (index, event) => {
        const values = [...kidTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setKidTravellers(values);
    };
    const handleInfantChange = (index, event) => {
        const values = [...infantTravellers];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setInfantTravellers(values);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        var temptravellerinfos = [];
        for (var i = 0; i < adultTravellers.length; i++) {
            if (validate(i, adultTravellers[i])) {
                var tempData = getformtravelData(adultTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        for (var i = 0; i < kidTravellers.length; i++) {
            if (validate(i, kidTravellers[i])) {
                var tempData = getformtravelData(kidTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        for (var i = 0; i < infantTravellers.length; i++) {
            if (validate(i, infantTravellers[i])) {
                var tempData = getformtravelData(infantTravellers[i]);
                temptravellerinfos = [...temptravellerinfos, tempData];
            }
        }
        if (errorAdult !== "" || errorKid !== "" || errorInfant !== "") {
            alert("Please check the errors");
        }
        else if (temptravellerinfos.length === totalTravellers) {

            const feePercent = DefaultData.DEFAULTPAYMENTGATEWAYFEE || 0;
            const feeAmount = Math.round(Number(totalFare) * (feePercent / 100));

            const flightBookingRequest = {
                flightBookingId: "00000000-0000-0000-0000-000000000000",
                userId: user?.id,
                branchId: user?.bid,
                bookingNo: '',
                pnr: '',
                isDomestic: params.isDomestic,
                isHold: false,
                supplierId: itinerary[0].fare.supplierId,
                travellerInfos: [],
                dcFlightLegs: legs,
                dcPriceDetails: itinerary.flatMap(item => item.fare),
                flightSearchRequest: searchQuery,
                baseFare: baseFare,
                tax: tax,
                totalFare: totalFare,
                totalPrice: totalPrice,
                convenienceFee: convenienceFee,
                gst: 0,
                gstAmount: 0,
                discount: discount,
                markup: 0,
                couponCode: '',
                email: email,
                mobile: mobile,
                transactionNo: '',
                paymentGatewayNo: '',
                paymentGatewayFee: feePercent, 
                paymentGatewayAmount: feeAmount,
                paymentGateway: 'RAZORPAY',
                paymentStatus: 'PENDING',
                bookingStatus: bookingStatus,
                companyGST: companyGST === '' ? DefaultData.DEFAULTCOMPANYGST : companyGST,
                companyName: companyName === '' ? DefaultData.DEFAULTCOMPANYNAME : companyName,
                companyAddress: companyAddress,
                requestedBy: DefaultData.USERTYPE,
                markup: passedMarkupINR,
            }
            flightBookingRequest.travellerInfos = temptravellerinfos;
            var flightBookingResponse = await apiService.post(config.REVIEWHFLIGHT, flightBookingRequest);
            console.log(flightBookingResponse);
            setBtnLoading(false);
            if (flightBookingResponse?.status === true) {
                navigate('/flight/review/' + params.adults + "/" + params.kids + "/" + params.infants + "/" + params.isDomestic, { state: { flightBookingResponse } });
            }
            else {
                alert(flightBookingResponse?.message===null? "Request flight is not available. Try different flight":flightBookingResponse?.message);
            }
        }
        else {
            setBtnLoading(false);
            alert("Please enter travelers data");
        }
    };
    const validatePassportDates = (travellerType, index, event) => {
        const { name, value } = event.target;
        const today = new Date();
        const inputDate = new Date(value);
        let values;

        if (travellerType === "adult") values = [...adultTravellers];
        if (travellerType === "kid") values = [...kidTravellers];
        if (travellerType === "infant") values = [...infantTravellers];

        let errors = { ...passportErrors };
        const errorKey = `${travellerType}_${index}_${name}`;

        if (name === "passbookIssueDate") {
            if (inputDate > today) {
                errors[errorKey] = "Passport issue date cannot be greater than today's date!";
                values[index][name] = "";
                setPassportErrors(errors);
                if (travellerType === "adult") setAdultTravellers(values);
                if (travellerType === "kid") setKidTravellers(values);
                if (travellerType === "infant") setInfantTravellers(values);
                return;
            } else {
                errors[errorKey] = "";
            }
        }

        if (name === "passbookExpireDate") {
            const minExpiry = new Date();
            minExpiry.setMonth(minExpiry.getMonth() + 6);

            if (inputDate <= minExpiry) {
                errors[errorKey] = "Passport expiry date must be at least 6 months from today!";
                values[index][name] = "";
                setPassportErrors(errors);
                if (travellerType === "adult") setAdultTravellers(values);
                if (travellerType === "kid") setKidTravellers(values);
                if (travellerType === "infant") setInfantTravellers(values);
                return;
            } else {
                errors[errorKey] = "";
            }
        }

        values[index][name] = value;
        if (travellerType === "adult") setAdultTravellers(values);
        if (travellerType === "kid") setKidTravellers(values);
        if (travellerType === "infant") setInfantTravellers(values);

        setPassportErrors(errors);
    };


    function getTimeFromMins(mins) {
        var h = mins / 60 | 0, m = mins % 60 | 0;
        var durationformat = h + "h " + m + "m";
        return durationformat;
    }
    useEffect(() => {
        if (state === null) {
            navigate('/flight/search')
        }
        else if (params === null) {
            navigate('/flight/search')
        }
        else if (state.searchQuery === null) {
            navigate('/flight/search')
        }
        else {
            console.log(state);
            const today = new Date().toISOString().split('T')[0];
            setMinDate(today);
            setSearchQuery(state.searchQuery);
            setItinerary(state.payload);
            const itinerary = state.payload;
            setBaseFare(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.basePrice || 0), 0).toFixed(2));
            setTax(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.tax || 0), 0).toFixed(2));
            setTotalFare(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.totalFare || 0), 0).toFixed(2));
            setTotalPrice(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.totalPrice || 0), 0).toFixed(2));
            setConvenienceFee(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.convenienceFee || 0), 0).toFixed(2));
            setPaymentGatewayFee(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayFee || 0), 0).toFixed(2));
            setPaymentGatewayAmount(Object.values(itinerary).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayAmount || 0), 0).toFixed(2));
            setTotalTravellers(parseInt(params.adults) + parseInt(params.kids) + parseInt(params.infants))
            const filteredFlights = state.payload.map(item => {
                const { dcPriceDetails, ...rest } = item.flightLeg;
                return rest;
            });
            setLegs(filteredFlights);
            const avalues = [...adultTravellers];
            if (adultTravellers.length < params.adults) {
                for (var i = 0; i < params.adults; i++) {
                    avalues.push({ title: "Mr", firstName: "", lastName: "", type: "ADULT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setAdultTravellers(avalues);
                }
            }
            const kvalues = [...kidTravellers];
            if (kidTravellers.length < params.kids) {
                for (var i = 0; i < params.kids; i++) {
                    kvalues.push({ title: "Master", firstName: "", lastName: "", type: "CHILD", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setKidTravellers(kvalues);
                }
            }
            const ivalues = [...infantTravellers];
            if (infantTravellers.length < params.infants) {
                for (var i = 0; i < params.infants; i++) {
                    ivalues.push({ title: "Master", firstName: "", lastName: "", type: "INFANT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
                    setInfantTravellers(ivalues);
                }
            }
        }
    }, [user, loading]);
    if (loading) return <p>Loading...</p>;
    if (!user) { navigate("/") };
    return (
        <div className="container-fluid" style={{ marginTop: "2px" }}>
            <div className="row">
                <div className="col-lg-8">
                    <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                        <h4 className="text-6 mb-3 mb-sm-4">Confirm Flight Details</h4>
                        <hr className="mx-n3 mx-sm-n4 mb-4" />
                        {itinerary.length > 0 && itinerary.map(it => (
                            it.flightLeg?.dcDisplayLegs?.length > 0 && it.flightLeg.dcDisplayLegs.map((leg, index) => (
                                <div className="card" key={index}>
                                    <div className="card-header">
                                        <div className="row align-items-center trip-title">
                                            <div className="col-5 col-sm-auto text-center text-sm-start">
                                                <h5 className="m-0 trip-place">{leg.startSegment.city}, {leg.startSegment.airportCode}</h5>
                                            </div>
                                            <div className="col-2 col-sm-auto text-8 text-black-50 text-center trip-arrow">➝</div>
                                            <div className="col-5 col-sm-auto text-center text-sm-start">
                                                <h5 className="m-0 trip-place">{leg.endSegment.city}, {leg.endSegment.airportCode}</h5>
                                            </div>
                                            <div className="col-12 mt-1 d-block d-md-none" />
                                            <div className="col-6 col-sm col-md-auto text-3 date">{moment(leg.startSegment.departureDateTime).format('DD MMM YY')}</div>
                                            <div className="col-6 col-sm col-md-auto text-end order-sm-1">
                                                <a className="text-1" data-bs-toggle="modal" data-bs-target={"#fare-rules-" + it.flightLeg?.supplierLegId} href>
                                                    Details
                                                </a>
                                            </div>
                                            <div className="col col-md-auto text-center ms-auto order-sm-0">
                                                {it.flightLeg?.refundable === "Refundable" ?
                                                    <span className="badge bg-success fw-normal text-1">{it.flightLeg?.refundable}</span>
                                                    :
                                                    <span className="badge bg-danger fw-normal text-1">{it.flightLeg?.refundable}</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-sm-3 text-center text-md-start d-lg-flex company-info">
                                                <span className="align-middle">
                                                    <img className="img-fluid" width={"30px"} height={"30px"} alt src={"/assets/images/airlinelogos/" + leg.airlineData.airlineCode + ".png"} /></span>
                                                <span className="align-middle ms-lg-2">
                                                    <span className="d-block text-2 text-dark mt-1 mt-lg-0">{leg?.airlineData?.airline}</span>
                                                    <small className="text-muted d-block">{leg?.airlineData?.airlineCode + "-" + leg?.airlineData?.equimentType + "-" + leg?.airlineData?.flightNumber}</small> </span> </div>
                                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                <span className="text-5 text-dark">{moment(leg?.startSegment?.departureDateTime).format("HH:mm")}</span>
                                                <small className="text-muted d-block">{moment(leg?.startSegment?.departureDateTime).format("DD MMM YY")}</small>
                                                <small className="text-muted d-block">{leg?.startSegment?.airportName}, {leg?.startSegment?.city}</small> </div>
                                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                <span className="text-3 text-dark">{getTimeFromMins(leg?.totalDuration)}</span>
                                                <small className="text-muted d-block">Duration</small>
                                                <small className='text-muted d-block'>{leg?.stops === 0 ? "Non Stop" : leg?.stops == 1 ? "1 Stop" : leg?.stops + "Stops"}</small> </div>
                                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                <span className="text-5 text-dark">{moment(leg?.endSegment?.arrivalDateTime).format("HH:mm")}</span>
                                                <small className="text-muted d-block">{moment(leg?.startSegment?.arrivalDateTime).format("DD MMM YY")}</small>
                                                <small className="text-muted d-block">{leg?.endSegment?.airportName}, {leg?.endSegment?.city}</small>
                                            </div>
                                        </div>
                                        <div id={"fare-rules-" + it.flightLeg?.supplierLegId} className="modal fade" role="dialog" aria-hidden="true">
                                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Flight Details</h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                    </div>
                                                    <div className="modal-body">
                                                        <ul className="nav nav-tabs" id="departureTab" role="tablist">
                                                            <li className="nav-item"> <a className="nav-link active" id={"second-tab" + it.flightLeg?.supplierLegId} data-bs-toggle="tab" href={"#second" + it.flightLeg?.supplierLegId} role="tab" aria-controls={"second" + it.flightLeg?.supplierLegId} aria-selected="false">Flight Details</a> </li>
                                                            <li className="nav-item"> <a className="nav-link" id={"third-tab" + it.flightLeg?.supplierLegId} data-bs-toggle="tab" href={"#third" + it.flightLeg?.supplierLegId} role="tab" aria-controls={"third" + it.flightLeg?.supplierLegId} aria-selected="false">Baggage Details</a> </li>
                                                            <li className="nav-item"> <a className="nav-link" id={"fourth-tab" + it.flightLeg?.supplierLegId} data-bs-toggle="tab" href={"#fourth" + it.flightLeg?.supplierLegId} role="tab" aria-controls={"fourth" + it.flightLeg?.supplierLegId} aria-selected="false">Cancellation Fee</a> </li>
                                                        </ul>
                                                        <div className="tab-content my-3">
                                                            <div className="tab-pane fade show active" id={"second" + it.flightLeg?.supplierLegId} role="tabpanel" aria-labelledby="second-tab">
                                                                <div className="flight-details">
                                                                    <div className="row align-items-center trip-title mb-3">
                                                                        <div className="col col-sm-auto text-center text-sm-start">
                                                                            <span className="m-0 fs-14">{it.flightLeg?.dcDisplayLegs?.[0]?.startSegment?.city}</span>
                                                                        </div>
                                                                        <div className="col-auto text-10 text-black-50 text-center trip-arrow">➝</div>
                                                                        <div className="col col-sm-auto text-center text-sm-start">
                                                                            <span className="m-0 fs-14">{it.flightLeg?.dcDisplayLegs?.[0]?.endSegment?.city}</span>
                                                                        </div>
                                                                        <div className="col col-sm-auto text-center text-sm-start">
                                                                            <span className="m-0 fs-14">Departure : {moment(it.flightLeg?.dcDisplayLegs?.[0]?.startSegment?.departureDateTime).format("Do MMM YY HH:mm")}</span>
                                                                        </div>
                                                                        <div className="col col-sm-auto text-center text-sm-start">
                                                                            <span className="m-0 fs-14">Arrival : {moment(it.flightLeg?.dcDisplayLegs?.[0]?.endSegment?.arrivalDateTime).format("Do MMM YY HH:mm")}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="tab-content my-3">
                                                                        {it.flightLeg?.dcSegments.length > 0 && it.flightLeg?.dcSegments.map(seg =>
                                                                            <>
                                                                                <div className="row flex-row pt-4 px-md-4">
                                                                                    <div className="col-12 col-sm-3 text-center d-lg-flex company-info"> <span className="align-middle"><img className="img-fluid" alt src={"/assets/images/airlinelogos/" + seg.tFAirlineData?.airlineCode + ".png"} /> </span> <span className="align-middle ms-lg-2"> <span className="d-block text-1 text-dark">{seg.tFAirlineData?.airline}</span> <small className="text-muted d-block">{seg.tFAirlineData?.equimentType + "-" + seg.tFAirlineData?.flightNumber}</small> </span> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFDepartureData.departureDateTime).format('HH:mm')}</span> <small className="text-muted d-block">{seg.tFDepartureData.airportName}, {seg.tFDepartureData.city}, {seg.tFDepartureData.terminal}</small> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-3 text-dark">{getTimeFromMins(seg.tFAirlineData?.duration)}</span> <small className="text-muted d-block">Duration</small> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFArrivalData.arrivalDateTime).format('HH:mm')}</span> <small className="text-muted d-block">{seg.tFArrivalData.airportName}, {seg.tFArrivalData.city},{seg.tFArrivalData.terminal}</small> </div>
                                                                                </div>
                                                                                {seg.tFAirlineData.connectingTime !== 0 ?
                                                                                    <div className="row flex-row pt-4 px-md-4">
                                                                                        <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                                                            <span className="badge bg-success">CONNECTING TIME : {getTimeFromMins(seg.tFAirlineData.connectingTime)}</span>
                                                                                        </div>
                                                                                    </div> : ''}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane fade" id={"third" + it.flightLeg?.supplierLegId} role="tabpanel" aria-labelledby="third-tab">
                                                                <div className="table-responsive-md">
                                                                    <table className="table table-hover table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>&nbsp;</th>
                                                                                <td className="text-center">Cabin</td>
                                                                                <td className="text-center">Check-In</td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Adult</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcAdults?.cabinBag}</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcAdults?.checkinBag}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Child</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcKids?.cabinBag}</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcKids?.checkinBag}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Infant</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcInfants?.cabinBag}</td>
                                                                                <td className="text-center">{it.flightLeg?.dcPriceDetails[0]?.dcInfants?.checkinBag}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane fade" id={"fourth" + it.flightLeg?.supplierLegId} role="tabpanel" aria-labelledby="fourth-tab">
                                                                <p className="fw-bold">Terms &amp; Conditions</p>
                                                                <ul>
                                                                    <li>The penalty is subject before departure. No Changes are allowed after that.</li>
                                                                    <li>The charges are per passenger per sector.</li>
                                                                    <li>Partial cancellation is not allowed on tickets booked under special discounted fares.</li>
                                                                    <li>In case of no-show or ticket not cancelled within the stipulated time, only statutory taxes are refundable subject to Service Fee.</li>
                                                                    <li>No Baggage Allowance for Infants</li>
                                                                    <li>Airline penalty needs to be reconfirmed prior to any amendments or cancellation.</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ))}

                        <div className="alert alert-info mt-4"> <span className="badge bg-info">NOTE:</span> This is a special fare given by the airline. Airlines cancellation charges do apply. </div>
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            {/* Overview */}
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="fw-semibold mb-0">Traveler Details</h6>
                                </div>
                                <div className="card-body">
                                    <div className="bg-success bg-opacity-10 rounded-2 p-3 mb-3">
                                        <p className="h6 text-md mb-0"><span className="badge bg-success me-2">New</span>Please enter your name as per your passport or pancard</p>
                                    </div>
                                    <div className="full-width d-flex flex-column mb-4 position-relative">
                                        <div className="row align-items-stat">
                                            {adultTravellers.length > 0 && adultTravellers.map((adult, index) =>
                                                <div>
                                                    <p className="fw-600">Adult {parseInt(index + 1)}</p>
                                                    <div className="row g-3 mb-4">
                                                        <div className="col-sm-3">
                                                            <labe>Title</labe>
                                                            <select className="form-select" name="title" required value={adult.title} onChange={(event) => handleAdultChange(index, event)}>
                                                                <option value="Mr">Mr</option>
                                                                <option value="Mrs">Mrs</option>
                                                                <option value="Ms">Ms</option>
                                                                <option value="Master">Master</option>
                                                            </select>
                                                            {errors.title === false ? (<div className="validationerror">Please select title </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <labe>Givenname</labe>
                                                            <input className="form-control" name="firstName" value={adult.firstName} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter First Name" type="text" />
                                                            {errors.firstName === false ? (<div className="validationerror">Please enter firstName </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <labe>Surname</labe>
                                                            <input className="form-control" name="lastName" value={adult.lastName} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter Surname" type="text" />
                                                            {errors.lastName === false ? (<div className="validationerror">Please enter surname </div>) : ('')}
                                                        </div>
                                                        {params.isDomestic === 'INTERNATIONAL' ?
                                                            <div className="col-sm-3">
                                                                <labe>Date Of Birth</labe>
                                                                <input className="form-control" name="dateOfBirth" value={adult.dateOfBirth} onBlur={(event) => validateAdultDate(index, event)} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter Date Of Birth" type="date" />
                                                                {errors.dateOfBirth === false ? (<div className="validationerror">Please enter date of birth </div>) : ('')}
                                                                {errorAdult && <div className="validationerror">{errorAdult}</div>}
                                                            </div>
                                                            : ""}
                                                    </div>
                                                    {params.isDomestic === 'INTERNATIONAL' ?
                                                        <div className="row g-3 mb-4">
                                                            <div className="col-sm-3">
                                                                <label>Passport No</label>
                                                                <input className="form-control" name="passportNo" value={adult.passportNo} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter Passport No" type="text" maxLength={10} />
                                                                {errors.passportNo === false ? (<div className="validationerror">Please enter passport no </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Nationality</label>
                                                                <select className="form-select" name="passportNationality" onChange={(event) => handleAdultChange(index, event)} value={adult.passportNationality} required>
                                                                    {countries.length > 0 && countries.map(cs =>
                                                                        <option value={cs.code}>{cs.name}</option>
                                                                    )}
                                                                </select>
                                                                {errors.passportNationality === false ? (<div className="validationerror">Please enter passportNationality </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Issue Date</label>
                                                                <input className="form-control" name="passbookIssueDate" value={adult.passbookIssueDate} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter Passport Issue Date" type="date" onBlur={(event) => validatePassportDates("adult", index, event)} />
                                                                {errors.passbookIssueDate === false ? (<div className="validationerror">Please enter passbookIssueDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookIssueDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Expiry Date</label>
                                                                <input className="form-control" min={minDate} name="passbookExpireDate" value={adult.passbookExpireDate} onChange={(event) => handleAdultChange(index, event)} required placeholder="Enter Passport Expiry Date" type="date" onBlur={(event) => validatePassportDates("adult", index, event)} />
                                                                {errors.passbookExpireDate === false ? (<div className="validationerror">Please enter passbookExpireDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookExpireDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                        : ""}
                                                </div>
                                            )}
                                            {kidTravellers.length > 0 && kidTravellers.map((adult, index) =>
                                                <div>
                                                    <p className="fw-600">CHILD {parseInt(index + 1)}</p>
                                                    <div className="row g-3 mb-3">
                                                        <div className="col-sm-3">
                                                            <label>Title</label>
                                                            <select className="form-select" name="title" required value={adult.title} onChange={(event) => handleKidsChange(index, event)}>
                                                                <option value="Ms">Ms</option>
                                                                <option value="Master">Master</option>
                                                            </select>
                                                            {errors.title === false ? (<div className="validationerror">Please select title </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label>Givenname</label>
                                                            <input className="form-control" name="firstName" value={adult.firstName} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Givenname" type="text" />
                                                            {errors.firstName === false ? (<div className="validationerror">Please enter givenname </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label>Surname</label>
                                                            <input className="form-control" name="lastName" value={adult.lastName} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Surname" type="text" />
                                                            {errors.lastName === false ? (<div className="validationerror">Please enter surname </div>) : ('')}
                                                        </div>
                                                        {params.isDomestic === 'INTERNATIONAL' ?
                                                            <div className="col-sm-3">
                                                                <label>Date Of Birth</label>
                                                                <input className="form-control" name="dateOfBirth" value={adult.dateOfBirth} onBlur={(event) => validateKidsDate(index, event)} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Date Of Birth" type="date" />
                                                                {errors.dateOfBirth === false ? (<div className="validationerror">Please enter date of birth </div>) : ('')}
                                                                {errorKid && <div className="validationerror">{errorKid}</div>}
                                                            </div> : ""}
                                                    </div>
                                                    {params.isDomestic === 'INTERNATIONAL' ?
                                                        <div className="row g-3 mb-3">
                                                            <div className="col-sm-3">
                                                                <label>Passport No</label>
                                                                <input className="form-control" name="passportNo" value={adult.passportNo} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Passport No" type="text" maxLength={10} />
                                                                {errors.passportNo === false ? (<div className="validationerror">Please enter passport no </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Nationality</label>
                                                                <select className="form-select" name="passportNationality" onChange={(event) => handleKidsChange(index, event)} value={adult.passportNationality} required>
                                                                    {countries.length > 0 && countries.map(cs =>
                                                                        <option value={cs.code}>{cs.name}</option>
                                                                    )}
                                                                </select>
                                                                {errors.passportNationality === false ? (<div className="validationerror">Please enter passportNationality </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Issue Date</label>
                                                                <input className="form-control" name="passbookIssueDate" value={adult.passbookIssueDate} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Passport Issue Date" type="date" onBlur={(event) => validatePassportDates("kid", index, event)} />
                                                                {errors.passbookIssueDate === false ? (<div className="validationerror">Please enter passbookIssueDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookIssueDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Expiry Date</label>
                                                                <input className="form-control" min={minDate} name="passbookExpireDate" value={adult.passbookExpireDate} onChange={(event) => handleKidsChange(index, event)} required placeholder="Enter Passport Expiry Date" type="date" onBlur={(event) => validatePassportDates("kid", index, event)} />
                                                                {errors.passbookExpireDate === false ? (<div className="validationerror">Please enter passbookExpireDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookExpireDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                        : ""}
                                                </div>
                                            )}
                                            {infantTravellers.length > 0 && infantTravellers.map((adult, index) =>
                                                <div>
                                                    <p className="fw-600">INFANT {parseInt(index + 1)}</p>
                                                    <div className="row g-3 mb-4">
                                                        <div className="col-sm-3">
                                                            <label>Title</label>
                                                            <select className="form-select" name="title" required value={adult.title} onChange={(event) => handleInfantChange(index, event)}>
                                                                <option value="Ms">Ms</option>
                                                                <option value="Master">Master</option>
                                                            </select>
                                                            {errors.title === false ? (<div className="validationerror">Please select title </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label>First Name</label>
                                                            <input className="form-control" name="firstName" value={adult.firstName} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter First Name" type="text" />
                                                            {errors.firstName === false ? (<div className="validationerror">Please enter firstName </div>) : ('')}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label>Last Name</label>
                                                            <input className="form-control" name="lastName" value={adult.lastName} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Last Name" type="text" />
                                                            {errors.lastName === false ? (<div className="validationerror">Please enter lastName </div>) : ('')}
                                                        </div>
                                                        {params.isDomestic === 'INTERNATIONAL' ?
                                                            <div className="col-sm-3">
                                                                <label>Date Of Birth</label>
                                                                <input className="form-control" name="dateOfBirth" value={adult.dateOfBirth} onBlur={(event) => validateInfantDate(index, event)} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Date Of Birth" type="date" />
                                                                {errors.dateOfBirth === false ? (<div className="validationerror">Please enter date of birth </div>) : ('')}
                                                                {errorInfant && <div className="validationerror">{errorInfant}</div>}
                                                            </div> : ""}
                                                    </div>
                                                    {params.isDomestic === 'INTERNATIONAL' ?
                                                        <div className="row g-3 mb-4">
                                                            <div className="col-sm-3">
                                                                <label>Passport No</label>
                                                                <input className="form-control" name="passportNo" value={adult.passportNo} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Passport No" type="text" maxLength={10} />
                                                                {errors.passportNo === false ? (<div className="validationerror">Please enter passport no </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Nationality</label>
                                                                <select className="form-select" name="passportNationality" onChange={(event) => handleInfantChange(index, event)} value={adult.passportNationality} required>
                                                                    {countries.length > 0 && countries.map(cs =>
                                                                        <option value={cs.code}>{cs.name}</option>
                                                                    )}
                                                                </select>
                                                                {errors.passportNationality === false ? (<div className="validationerror">Please enter passport Nationality </div>) : ('')}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Issue Date</label>
                                                                <input className="form-control" name="passbookIssueDate" value={adult.passbookIssueDate} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Passport Issue Date" type="date" onBlur={(event) => validatePassportDates("infant", index, event)} />
                                                                {errors.passbookIssueDate === false ? (<div className="validationerror">Please enter passbook IssueDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookIssueDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <label>Passport Expiry Date</label>
                                                                <input className="form-control" min={minDate} name="passbookExpireDate" value={adult.passbookExpireDate} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Passport Expiry Date" type="date" onBlur={(event) => validatePassportDates("infant", index, event)} />
                                                                {errors.passbookExpireDate === false ? (<div className="validationerror">Please enter passbook ExpireDate </div>) : ('')}
                                                                {passportErrors[`${index}_passbookExpireDate`] && (<div className="validationerror">{passportErrors[`${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                        : ""}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="full-width d-flex flex-column mb-2 position-relative">
                                        <div className="row align-items-stat">
                                            <div className="col-xl-12 col-lg-12 col-md-12 mb-2">
                                                <h5>Personal Information</h5>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Email Address</label>
                                                    <input type="text" maxLength={45} value={email} name="email" onChange={handleEmailChange} className="form-control" placeholder="Email Here" />
                                                    {errors.email === false ? (<div className="validationerror">Please enter email </div>) : ('')}
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Mobile number</label>
                                                    <input type="text" maxLength={12} value={mobile} name="mobile" onChange={handleMobileChange} className="form-control" placeholder="Mobile Number" />
                                                    {errors.mobile === false ? (<div className="validationerror">Please enter mobile </div>) : ('')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="full-width d-flex flex-column mb-2 position-relative mt-4">
                                        <div className="row align-items-stat">
                                            <div className="col-xl-12 col-lg-12 col-md-12 mb-2">
                                                <h5>GST Information (optional)</h5>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">GST Number</label>
                                                    <input autoComplete="off" type="text" maxLength={25} value={companyGST} name="companyGST" onChange={(e) => setCompanyGST(e.target.value)} className="form-control" placeholder="Company GST Number" />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Registered Company Name</label>
                                                    <input autoComplete="off" type="text" maxLength={100} value={companyName} name="companyName" onChange={(e) => setCompanyName(e.target.value)} className="form-control" placeholder="Company Name" />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Company Address</label>
                                                    <input autoComplete="off" type="text" value={companyAddress} name="companyAddress" onChange={(e) => setCompanyAddress(e.target.value)} className="form-control" placeholder="Company Address" />
                                                </div>
                                                <div className="d-grid mt-4">
                                                    {btnLoading === true ?
                                                        <button className="btn btn-primary" type="button" disabled>Confirming...</button> :
                                                        <button className="btn btn-success" onClick={e => handleSubmit(e)} type="submit">Confirm Booking</button>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Side Panel (Fare Details)
    ============================================= */}
                <aside className="col-lg-4 mt-4 mt-lg-0">
                    <div className="bg-white shadow-md rounded p-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className="text-5 mb-0">Fare Details</h3>
                            {/* Optional: Currency Selector (same as list screen) */}
                            <select className="form-select form-select-sm w-auto" style={{ minWidth: '100px' }}

                                value={currency} 
                                onChange={(e) => {
                                    const selected = e.target.value;
                                    setCurrency(selected);
                                    const rate = exchangeRates.find(r => r.toCurrency === selected)?.price || 1;
                                    setConversionFactor(rate);
                                }}
                            >
                                <option value="INR">INR</option>
                                {exchangeRates.map((r, i) => <option key={i} value={r.toCurrency}>{r.toCurrency}</option>)}
                            </select>
                        </div>
                        
                        <hr className="mx-n3" />
                        
                        <ul className="list-unstyled">
                            {/* BASE FARE */}
                            <li className="mb-2">
                                Base Fare 
                                <span className="float-end text-4 fw-500 text-dark">
                                    {currency} {calculatePrice(baseFare)}
                                </span>
                                <br />
                                <small className="text-muted">Adult : {params.adults}, Child : {params.kids}, Infant : {params.infants}</small>
                            </li>

                            {/* TAXES & FEES (Markup added here) */}
                            <li className="mb-2">
                                Taxes &amp; Fees 
                                <span className="float-end text-4 fw-500 text-dark">
                                    {/* Math: (Tax + Gateway + Convenience + Markup) then converted */}
                                    {currency} {calculatePrice(
                                        parseFloat(tax) + 
                                        parseFloat(paymentGatewayAmount) + 
                                        parseFloat(convenienceFee) + 
                                        passedMarkupINR
                                    )}
                                </span>
                                
                            </li>
                        </ul>

                        <div className="text-dark bg-light-4 p-2 rounded text-4 fw-600"> 
                            Total Amount 
                            <span className="float-end text-6 text-primary">
                                {currency} {calculatePrice(parseFloat(totalPrice) + passedMarkupINR)}
                            </span>
                        </div>
                    </div>
                </aside>
                {/* Side Panel End */}
            </div>
        </div>
    );
};

export default FlightDetails;
